import {Box, Button, Typography} from "@mui/material";
import React from "react";
import PermissionCheck from "./components/permissionCheck.tsx";
import {useNavigate} from "react-router";
import TicketList from "./components/TicketList/index.tsx";

const Ticket: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Box className="px-4 md:px-8 pt-6" sx={{height: "calc(100vh - 72px)"}}>
            <PermissionCheck/>
            <Box className="flex pb-4 justify-between ">
                <Box className="hidden md:flex items-center">
                    <Typography className="pl-2">Tickets</Typography>
                </Box>
                <Box className="w-full md:w-fit">
                    <Button
                        style={{
                            backgroundColor: "#0077B2",
                            color: "#fff",
                            textTransform: "none",
                            padding: "10px 18px",
                            fontSize: "1rem",
                            width: "100%",
                        }}
                        onClick={() => navigate(`/chat/new`)}
                    >
                        Raise Ticket
                    </Button>
                </Box>
            </Box>
            <TicketList/>
        </Box>
    );
};

export default Ticket;
